import { Box, Container, Paper, Typography } from '@mui/material';
import React from 'react'
import Navbar from './Navbar';
import Footer from './Footer';

export const RegistrationTerms = () => {
    const termRegistrationContent = `
    <br />
    <h3>Welcome to IND Matrimony!</h3>
    
    <p>By registering on the IND Matrimony platform, you agree to the following terms and conditions, which govern your use of our services. Please read them carefully.</p>

    <strong>1. Eligibility</strong>
    <p>You must be at least 18 years old (21 for males and 18 for females as per Indian law) to register on IND Matrimony.</p>
    <p>By registering, you confirm that you are legally competent to marry as per the laws of India or your country of residence.</p>
    <p>Individuals who have been prohibited from using the platform by applicable law or court orders are not permitted to register.</p>

    <strong>2. Accuracy of Information</strong>
    <p>You agree to provide true, accurate, current, and complete information about yourself in the registration form.</p>
    <p>Providing false or misleading information may result in suspension or termination of your account.</p>

    <strong>3. Mobile Number Verification</strong>
    <p>Your registration requires verification of your mobile number via OTP.</p>
    <p>By providing your mobile number, you consent to receive communications, alerts, and OTPs from IND Matrimony.</p>

    <strong>4. Account Responsibility</strong>
    <p>You are responsible for maintaining the confidentiality of your account credentials.</p>
    <p>You agree to immediately notify us of any unauthorized use of your account.</p>

    <strong>5. Purpose of Registration</strong>
    <p>Registration on IND Matrimony is intended strictly for individuals seeking a life partner for lawful marriage.</p>
    <p>Commercial use, fraudulent intentions, or misrepresentation of identity will result in immediate account termination.</p>

    <strong>6. Content Guidelines</strong>
    <p>You are solely responsible for the content and photos you upload.</p>
    <p>Any objectionable, abusive, or misleading content is strictly prohibited and may be removed without notice.</p>

    <strong>7. Privacy and Data Use</strong>
    <p>Your data will be processed in accordance with our <a href="/privacy-policy">Privacy Policy</a>.</p>
    <p>You consent to the use of your information for matchmaking purposes within the app.</p>

    <strong>8. Termination</strong>
    <p>IND Matrimony reserves the right to suspend or terminate your registration at any time if found in violation of these terms.</p>

    <strong>9. Changes to Terms</strong>
    <p>These terms may be updated from time to time. Continued use of the app constitutes your acceptance of the updated terms.</p>

    <strong>10. Contact</strong>
    <p>For any queries related to registration or these terms, please contact us at <a href="mailto:support@indmatrimony.com">support@indmatrimony.com</a>.</p>
`;

return (
    <Box>
        <Navbar />
        <Box mt={12}>
            <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
                <Paper elevation={6} sx={{ p: 4, mb: 6, width: '80%', mx: 'auto' }}>
                    <Box textAlign="center" mb={12} mt={5}>
                        <Typography
                            variant="h4"
                            component="strong"
                            gutterBottom
                            sx={{ fontFamily: "Montserrat" }}
                        >
                           Terms of Registration
                        </Typography>
                        <div className='text-left' dangerouslySetInnerHTML={{ __html: termRegistrationContent }} />
                    </Box>
                </Paper>
            </Container>
        </Box>
        <Footer />
    </Box>
);
}
